// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pnXtQ","title":"styles_title__l9fNt","iconContainer":"styles_iconContainer__DGYTC","inputSearch":"styles_inputSearch__YWoTX"};